import '../../stylesheets/Poi.css';
import { selectAllStrings } from '../language/languageSlice';
import { useSelector } from 'react-redux';
import { constants } from '../../constants';
import { parsePoiAdvantages, parsePoiAddress, parseTrendingPoiAdvantages, parseTrendingPoiAddress } from './parser';
import { selectFeaturedPoiById, selectTrendingPoiById } from './poisSlice';
import { useHistory } from 'react-router-dom';


const PoiSlide = ({poiId, selector = selectFeaturedPoiById, showControls = false, onDelete=f=>f}) => {
    const strings = useSelector(selectAllStrings);
    const poi = useSelector((state) => selector(state, poiId));
    const history = useHistory();

    return (<section className="poi" onClick={event => history.push(`/pois/${poiId}`)}>
        <div className="image">
            <img alt="poi" src={poi.image || poi.large_image}/>
        </div>
        <span className="title">{poi.nome_poi}</span>
        <span className="advantages">{parsePoiAdvantages(poi, strings)}</span>
        <span className="address">{parsePoiAddress(poi)}</span>
        {showControls ? <div className="controls">
            <a href="#" 
               onClick={event => onDelete(event, poiId)}>{strings.delete}</a>
        </div> : null}
    </section>);
};

const TrendingPoiSlide = ({poiId, selector = selectTrendingPoiById, showControls = false, onDelete=f=>f}) => {
    const strings = useSelector(selectAllStrings);
    const poi = useSelector((state) => selector(state, poiId));
    const history = useHistory();

    return (<section className="poi trending" onClick={event => history.push(`/pois/${poiId}`)}>
        <div className="image">
            <img alt="poi" src={poi.image || poi.large_image}/>
        </div>
        <span className="title">{poi.nome_poi}</span>
    
        <span className="address">{parseTrendingPoiAddress(poi)}</span>
        <span className="advantages">{parseTrendingPoiAdvantages(poi, strings) || parsePoiAdvantages(poi, strings)}</span>
        {showControls ? <div className="controls">
            <a href="#" 
               onClick={event => onDelete(event, poiId)}>{strings.delete}</a>
        </div> : null}
    </section>);
};

const PoisSlider = ({poiIds, status, error, layout, selectById, showControls = false, onDelete=f=>f}) => {
    const strings = useSelector(selectAllStrings);

    return (<div className="pois-slider" onTouchStart={e => e.stopPropagation()} onTouchMove={e => e.stopPropagation()}>
        <div className="feed">
            {status === 'loading' ? <div className="loader"></div> : status === 'succeeded' ? poiIds.length > 0 ? poiIds.map((poiId) => (layout == 'trending' ?
                        <TrendingPoiSlide poiId={poiId} key={poiId} selector={selectById} showControls={showControls} onDelete={onDelete}/> :
                        <PoiSlide poiId={poiId} key={poiId} 
                                  selector={selectById} showControls={showControls} onDelete={onDelete}/>)) : <div>{strings.pois_not_found}</div> :
                            status === 'failed' ? <div>{error}</div> : null}
        </div>
    </div>);
};

export default PoisSlider;